import { createContext, useEffect, useState } from "react";
import clienteAxios from "../config/clienteAxios";
import { toast } from "react-hot-toast";

const SectionClientsContext = createContext();

const SectionClientsProvider = ({ children }) => {
  const [multimedias, setMultimedias] = useState([]);
  const [loading, setLoading] = useState(true);

  const obtenerMultimedia = async () => {
    try {
      const { data } = await clienteAxios.get("/multimedia/getall");
      setMultimedias(data?.allMultimedia)
    } catch (error) {
      console.log(error);
    }
  };
  
  useEffect(() => {
    obtenerMultimedia()
  }, []);

  useEffect(() => {
    if(multimedias?.length !== 0){
      setLoading(false)
    }
  }, [multimedias]);

  const editMultimedia = async (multimediaEdit) => {
    try {
      await clienteAxios.put(`multimedia/update`, multimediaEdit);
      setMultimedias([multimediaEdit])
      toast.success("Se actualizó sección Clientes");
    } catch (error) {
      toast.error("Error al actualizar sección Clientes");
    }
  };

  return (
    <SectionClientsContext.Provider
      value={{
        multimedias,
        obtenerMultimedia,
        editMultimedia,
        loading
      }}
    >
      {children}
    </SectionClientsContext.Provider>
  );
};

export { SectionClientsProvider };

export default SectionClientsContext;